import type { FC } from 'react';
import { Flows } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { Add } from '@mui/icons-material';
import { LinkButton } from 'components/common';
import { Guard, usePermissionGuard } from 'features/login';

const FlowsPage: FC = () => {
  const { accessToAddFlow, accessToViewFlow } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewFlow} fallback>
      <CabinetTitlePage
        title={'Flows'}
        endAdornment={
          <LinkButton
            disabled={!accessToAddFlow}
            to={'/cabinet/facebook/flows/add'}
            title={'Add flow'}
            startIcon={<Add />}
          />
        }
      />
      <Flows />
    </Guard>
  );
};

export default FlowsPage;
